export default "__VITE_ASSET__Ne$3MVwT__"